import { render, staticRenderFns } from "./IntroPromotionList.vue?vue&type=template&id=711e93b2&scoped=true&"
import script from "./IntroPromotionList.vue?vue&type=script&lang=js&"
export * from "./IntroPromotionList.vue?vue&type=script&lang=js&"
import style0 from "./IntroPromotionList.vue?vue&type=style&index=0&id=711e93b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711e93b2",
  null
  
)

export default component.exports